export default __webpack_public_path__ + "static/media/success.3456996a.ogg";